import React, { useEffect } from "react";
import { Helmet } from "react-helmet";
import "./About.css";
import Navbar from "./Navbar";
import Footer from "./Footers";

export default function About() {
  const businessName = "Express Engineering";
  const subBrand = "SERV E2E";
  const foundedYear = 2019;

  // 🔹 Scroll to top when the page loads
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);

  const description =
    `${businessName} – trusted home appliance service since ${foundedYear}. ` +
    `${subBrand} provides fast, honest repairs for Washing Machines, Air Conditioners, Fridges, and Water Purifiers. ` +
    "We believe strong customer relationships and genuine service quality are the keys to our success.";

  const structuredData = {
    "@context": "https://schema.org",
    "@type": "LocalBusiness",
    name: businessName,
    alternateName: subBrand,
    description: description,
    foundingDate: `${foundedYear}`,
    serviceType: [
      "Washing Machine Repair",
      "AC Repair",
      "Fridge Repair",
      "Water Purifier Service"
    ],
    url: window.location.origin,
    telephone: "+91777 000 5768",
    address: {
      "@type": "PostalAddress",
      addressLocality: "Madurai",
      addressRegion: "Tamil Nadu",
      addressCountry: "IN"
    }
  };

  return (
    <>
      <Navbar />
      <main className="about-page">
        <Helmet>
          <title>About • {businessName} | {subBrand}</title>
          <meta name="description" content={description} />
          <meta
            name="keywords"
            content="Washing machine service, AC repair, fridge repair, water purifier service, Express Engineering, SERV E2E, AMC"
          />
          <meta name="robots" content="index, follow" />
          <script type="application/ld+json">
            {JSON.stringify(structuredData)}
          </script>
        </Helmet>

        <section className="about-hero">
          <div className="hero-left">
            <h1>{businessName}</h1>
            <h2>
              <span className="subbrand">{subBrand}</span> — Trusted Since {foundedYear}
            </h2>
            <p className="lead">
              Express Engineering and its sub-brand SERV E2E have been serving
              customers with reliable, quick, and transparent appliance repair services since {foundedYear}.
              From Home Appliance Services 
              we handle every repair with genuine care and expertise.
            </p>
<div className="cta-row">
  <a href="tel:+91777 000 5768" className="btn primary">📞 Contact Us</a>
  <a href="/" className="btn ghost">Book Your Service</a>
</div>


          </div>
          <div className="hero-right">
            <div className="brand-visual">SERV E2E</div>
          </div>
        </section>


<section className="about-growth">
  <h3>Our Growth & Team Strength</h3>
  <p>
    Since <strong>2019</strong>, <strong>Express Engineering</strong> and its sub-brand 
    <strong> SERV E2E</strong> have grown from a small service startup in 
    <strong> Madurai</strong> to one of the most <strong>trusted home appliance 
    service networks in Tamil Nadu</strong>. Our consistent quality, 
    quick response, and transparent repair process have earned the trust 
    of thousands of households.
  </p>
  <p>
    Today, we operate from our <strong>dedicated 2,613.6 square feet corporate office</strong> 
    — a symbol of our continued success and commitment to professional service. 
    With advanced tools, trained experts, and a state-wide support network, 
    we deliver <strong>reliable repair and maintenance services</strong> for 
    <strong> washing machines, ACs, fridges, and water purifiers</strong> 
    across Tamil Nadu.
  </p>
  <p>
    Our journey is powered by people — a passionate team of technicians 
    who go the extra mile to keep your home running smoothly. From doorstep 
    diagnosis to post-service follow-ups, we ensure every customer 
    experiences <strong>genuine care and satisfaction</strong>.
  </p>

  <div className="growth-stats">
    <div className="stat-box">
      <h4>🏢 2,613.6 square feet Head Office</h4>
      <p>Established hub for managing operations and customer support.</p>
    </div>
    <div className="stat-box">
      <h4>👨‍🔧 30+ Madurai Experts</h4>
      <p>Specialized technicians delivering same-day repairs locally.</p>
    </div>
    <div className="stat-box">
      <h4>🌍 90+ Other District Technicians</h4>
      <p>Trusted professionals serving homes across Tamil Nadu.</p>
    </div>
    <div className="stat-box">
      <h4>💪 120+   Total Technicians</h4>
      <p>Strong team ensuring reliable appliance service everywhere.</p>
    </div>
  </div>
</section>


        <section className="about-story">
          <h3>Our Journey</h3>
          <p>
            Founded in {foundedYear}, {businessName} began as a small service team
            focused on honest workmanship and customer satisfaction. Over the years,
            we’ve grown into a trusted name for thousands of homes across the region.
            Our success story is built on strong relationships, genuine repairs, and consistent follow-ups.
          </p>

          <div className="pill-list">
            <div className="pill">
              <h4>🔧 Experience</h4>
              <p>Trained and certified technicians delivering quality appliance repair services.</p>
            </div>
            <div className="pill">
              <h4>💯 Trust</h4>
              <p>Clear pricing, Replacement Parts, and transparent service at every step.</p>
            </div>
            <div className="pill">
              <h4>⚡ Quick Response</h4>
              <p>Same-day or next-day service for most issues, anywhere in your city.</p>
            </div>
          </div>
        </section>

        <section className="about-values">
          <h3>Our Promises</h3>
          <ul>
            <li>✔️ Transparency — no hidden charges or fake commitments</li>
            <li>✔️ Long-term relationships — many of our customers return year after year</li>
            <li>✔️ Accountability — we follow up even after the service is completed</li>
          </ul>
        </section>

        <section className="about-contact">
          <h3>Contact & Trust</h3>
          <p>
            Get in touch with our expert technicians and experience why thousands
            trust {businessName} and {subBrand} for all their home appliance service needs.
          </p>
          <div className="contact-row">
            <a className="contact-item" href="tel:+91777 000 5768">
              📞 +91  +91777 000 5768
            </a>
            <a
              className="contact-item"
              href="mailto:expresshelplinecare@gmail.com"
            >
              ✉️ expresshelplinecare@gmail.com
            </a>
          </div>
        </section>

        <Footer />
      </main>
    </>
  );
}
